
/**
 * 메시지 역할
 */
export type ChatBodyMessagesItemRole = typeof ChatBodyMessagesItemRole[keyof typeof ChatBodyMessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatBodyMessagesItemRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system',
} as const;
